import RewardsView from './RewardsView';

export default RewardsView;
